module.exports = __webpack_public_path__ + "img/healththink official  logo.cf090642.svg";